<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="宴会厅管理">
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div
      class="content c-table-box mt-2 bg-white p-2.5 rounded-lg"
      v-if="state.list_data?.length > 0"
    >
      <div class="overflow-y-auto flex flex-col gap-y-3 mt-3">
        <div
          class="bg-white p-4 flex flex-col gap-y-2 border-gray-100"
          :class="index != 0 ? 'border-t' : ''"
          v-for="(item, index) in state.list_data"
          :key="item"
        >
          <ul class="flex gap-x-5 mb-1">
            <strong class="text-lg">{{ item.name }}</strong>
            <c_cell title="楼层" :value="item.floor + '楼'" />
            <c_cell title="长度" :value="item.hall_length + 'm'" />
            <c_cell title="宽度" :value="item.hall_width + 'm'" />
            <c_cell title="高度" :value="item.hall_height + 'm'" />
            <el-button
              type="primary"
              plain
              link
              @click="
                state.selectId = item.id;
                state.showInfo = true;
              "
            >
              <template #icon>
                <el-icon :size="18" class="font-bold">
                  <Edit />
                </el-icon>
              </template>
            </el-button>
            <el-button
              type="danger"
              plain
              link
              @click="onDelete(item)"
              style="margin-left: -5px"
            >
              <template #icon>
                <el-icon :size="18" class="font-bold">
                  <Delete />
                </el-icon>
              </template>
            </el-button>
          </ul>
          <c_cell title="说明">
            <template #default>
              <div class="whitespace-pre-wrap">
                {{ item.intro }}
              </div>
            </template>
          </c_cell>
          <c_cell title="附件">
            <template #default>
              <c_UploadFile
                v-if="item.attachment_img?.length > 0"
                :key="item.attachment_img"
                :value="item.attachment_img"
                :showAdd="false"
              />
              <text v-else>-</text>
            </template>
          </c_cell>
          <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
            <text class="text-sm text-gray-600">
              {{ item?.add_admin_name }}
            </text>
            <text>{{ item?.add_department_name }}</text>
            <text class="ml-1">{{ item?.create_time }} 创建</text>
          </div>
        </div>
      </div>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
    <div class="text-center" v-else>
      <el-image :src="require('@/assets/images/nodata.png')" />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑宴会厅' : '新建宴会厅'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      :hotel_id="props.hotel_id"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { hotel_hall_page, hotel_hall_delete } from "@/http/hotel";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    hotel_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.hotel_id = props.hotel_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      hotel_hall_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(hotel_hall_delete, row.id, onLoad, {
        filed: "宴会厅",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
